import { Injectable } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { TrackingEvent } from '../model/tracking/tracking.model';

@Injectable()
export class TrackingService {

    constructor(private angulartics: Angulartics2) {
    }

    trackEvent(event: TrackingEvent): void {
        this.angulartics.eventTrack.next(event);
    }

    trackStep(path: string): void {
        this.angulartics.pageTrack.next({ path });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/tracking.service.ts